import {
  collection,
  composeReducers,
} from 'common/store/reducer';

import {
  LOAD,
  NAMESPACE,
} from './actions';

const initialState = {
  to: null,
  from: null,
};

const loadAlarms = (
  state,
  { deviceId = state.deviceId, from = state.from, to = state.to, ...props },
) => ({
  ...collection.load(state, props),
  deviceId,
  from,
  to,
});

export default composeReducers(
  collection.factory(NAMESPACE),
  (state = initialState, action) => {
    const reducer = {
      [LOAD]: loadAlarms,
    }[action.type];

    return reducer ? reducer(state, action) : state;
  },
);
